import * as yup from 'yup';

export const ValidationContactSchema = yup.object({
  name: yup
    .string()
    .min(2, 'Inserisci almeno 2 caratteri')
    .max(50, 'Inserire un massimo di 50 caratteri')
    .required('Campo obbligatorio'),
  company_name: yup
    .string()
    .min(2, 'Inserisci almeno 2 caratteri')
    .max(50, 'Inserire un massimo di 50 caratteri')
    .required('Campo obbligatorio'),
  surname: yup
    .string()
    .min(2, 'Inserisci almeno 2 caratteri')
    .max(50, 'Inserire un massimo di 50 caratteri')
    .required('Campo obbligatorio'),
  phone: yup
    .string()
    .min(3, 'Inserisci almeno 3 caratteri')
    .max(50, 'Inserire un massimo di 50 caratteri')
    .required('Campo obbligatorio'),
  email: yup.string().email('Email non valida').required('Campo obbligatorio'),
  message: yup.string().max(250, 'Inserire un massimo di 250 caratteri'),
});
